import React, { useRef } from 'react';
import { useMutation } from 'react-query';
import { createAttachment } from '../../../api/objective/attachments.api';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { MAX_ATTACHMENT_SIZE } from '../../../utils/const';
import { useTranslation } from 'react-i18next';

const CreateAttachment = ({
  objectiveId,
  ownerId,
  ownerType,
  onSuccess
}) => {
  const { t } = useTranslation();

  const inputRef = useRef(null);

  const mutation = useMutation(
    async file => {
      if (file.size > MAX_ATTACHMENT_SIZE * 1048576) {
        throw new Error(`Túl big ${MAX_ATTACHMENT_SIZE}MB max`);
      }
      return await createAttachment({
        file,
        objectiveId,
        ownerId,
        ownerType
      });
    },
    {
      onSuccess,
      onSettled: () => {
        inputRef.current.value = null;
      }
    }
  );

  const inputId = `file-${objectiveId}`;

  return <>
    <Button
      color='secondary'
      variant="contained"
      component="label"
      htmlFor={ inputId }
    >
      {t('objective.attachment.create')}
      <input
        ref={ inputRef }
        onChange={ e => {
          mutation.mutate(e.target.files[0]);
        } }
        type='file'
        id={ inputId }
        hidden
      />
    </Button>
    <Dialog open={ mutation.isError }>
      <DialogContent>
        {mutation.error?.message}
      </DialogContent>
      <DialogActions>
        <Button onClick={ mutation.reset }>OK</Button>
      </DialogActions>
    </Dialog>
  </>;
};

export default CreateAttachment;